import { Link } from "react-router-dom";
import { CheckboxField, InputField } from "../../common";

const Step3 = () => {
  return (
    <article className="fields-wrapper">
      <InputField
        name="name"
        label="Name"
        rules={{ required: "This field is required" }}
      />

      <InputField
        name="email"
        inputProps={{ type: "email" }}
        label="Email"
        rules={{ required: "This field is required" }}
      />

      <InputField
        name="phone"
        inputProps={{ type: "number" }}
        label="Phone Number"
        rules={{ required: "This field is required" }}
      />

      <article className="sms-consent-wrapper">
        <CheckboxField
          name="smsConsent"
          label={
            <span className="sms-consent-text">
              By checking this box, I consent to receive conversational SMS
              messages from Super Hauling Inc, including vehicle transport
              quotes, carrier dispatch updates, pickup and delivery
              notifications, appointment reminders, and customer support
              messages. Message frequency may vary. Msg & data rates may apply.
              This consent is not a condition of purchase. Reply STOP to
              unsubscribe or HELP for assistance. <strong>(Optional)</strong>{" "}
              View our{" "}
              <Link target="_blank" to="/privacy-policy">
                Privacy Policy
              </Link>{" "}
              and{" "}
              <Link target="_blank" to="/terms-conditions">
                Terms & Conditions
              </Link>
              .
            </span>
          }
        />
      </article>

      <CheckboxField
        name="terms"
        inputProps={{ required: true }}
        label={
          <>
            Agreed to the{" "}
            <Link target="_blank" to="/terms-conditions">
              Terms & Conditions
            </Link>{" "}
            and{" "}
            <Link target="_blank" to="/shipper-agreement">
              Shipper Agreement
            </Link>
            .
          </>
        }
      />
    </article>
  );
};

export default Step3;


